// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3RRKi","alert":"SettungsInbox_alert__1hB0-"};